function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsModern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "events_modern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    d: "m7.4 16.4 3.6-2.745 3.6 2.745-1.35-4.455 3.6-2.565h-4.41L11 4.7 9.56 9.38H5.15l3.6 2.565zM11 20a8.759 8.759 0 0 1-3.51-.709 8.98 8.98 0 0 1-4.781-4.781A8.759 8.759 0 0 1 2 11a8.759 8.759 0 0 1 .709-3.51A8.986 8.986 0 0 1 7.49 2.708 8.769 8.769 0 0 1 11 2a8.769 8.769 0 0 1 3.51.708 8.986 8.986 0 0 1 4.781 4.782A8.759 8.759 0 0 1 20 11a8.759 8.759 0 0 1-.709 3.51 8.98 8.98 0 0 1-4.781 4.781A8.759 8.759 0 0 1 11 20z",
    transform: "translate(1 1)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsModern);
export default __webpack_public_path__ + "static/media/events_modern.1e0895f790bd3c5d79d335ba5aa4f690.svg";
export { ForwardRef as ReactComponent };